/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='spineAttachments'>
        <Sprite name='texts'>
            <Sprite name='title'>
                <Image src='winner_en' />
            </Sprite>
            <Sprite name='winContainer'>
                <Text
                    position={[-750, 20]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 324, fontWeight: 'bold', fill: '#FFFFFF', align: 'left' }}
                    maxWidth={1500}
                    name='winText'
                    text='$20000343'
                />
            </Sprite>
            <Sprite name='winRespinContainer'>
                <Text
                    position={[-750, 20]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 324, fontWeight: 'bold', fill: '#FFFFFF', align: 'left' }}
                    maxWidth={1500}
                    name='winTextRespin'
                    text='$20000343'
                />
            </Sprite>
        </Sprite>
        <Sprite name='buttons'>
            <Button hitArea={{ width: 1009, x: 20, y: 19, type: 'rectangle', height: 283 }} name='start'>
                <Sprite>
                    <Image src='popup_button_normal' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonStart'
                        text='START'
                    />
                </Sprite>
                <Sprite>
                    <Image src='popup_button_focused' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonStart'
                        text='START'
                    />
                </Sprite>
                <Sprite>
                    <Image src='popup_button_pressed' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 140,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonStart'
                        text='START'
                    />
                </Sprite>
                <Sprite>
                    <Image src='popup_button_disabled' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#C5C5C9',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonStart'
                        text='START'
                    />
                </Sprite>
            </Button>
            <Button hitArea={{ width: 1009, x: 20, y: 19, type: 'rectangle', height: 283 }} name='collect'>
                <Sprite>
                    <Image src='popup_button_normal' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonCollect'
                        text='COLLECT'
                    />
                </Sprite>
                <Sprite>
                    <Image src='popup_button_focused' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonCollect'
                        text='COLLECT'
                    />
                </Sprite>
                <Sprite>
                    <Image src='popup_button_pressed' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 140,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonCollect'
                        text='COLLECT'
                    />
                </Sprite>
                <Sprite>
                    <Image src='popup_button_disabled' />
                    <Text
                        position={[524, 160]}
                        anchor={[0.5, 0.5]}
                        style={{
                            fontFamily: 'PF DinDisplay Pro',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#D0CFD1',
                            align: 'center',
                            fontWeight: 'bold'
                        }}
                        maxWidth={800}
                        name='title'
                        localeTextID='buttonCollect'
                        text='COLLECT'
                    />
                </Sprite>
            </Button>
            <Button hitArea={{ width: 1009, x: 20, y: 19, type: 'rectangle', height: 283 }} name='buy'>
                <Sprite>
                    <Image name='btn' src='popup_button_normal' />
                    <Text
                        position={[150, 76]}
                        style={{
                            fontFamily: 'Arial',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'normal'
                        }}
                        maxWidth={800}
                        name='text'
                        localeTextID=''
                        text='BUY'
                    />
                </Sprite>
                <Sprite>
                    <Image name='btn' src='popup_button_focused' />
                    <Text
                        position={[150, 76]}
                        style={{
                            fontFamily: 'Arial',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'normal'
                        }}
                        maxWidth={800}
                        name='text'
                        localeTextID=''
                        text='BUY'
                    />
                </Sprite>
                <Sprite>
                    <Image name='btn' src='popup_button_pressed' />
                    <Text
                        position={[150, 76]}
                        style={{
                            fontFamily: 'Arial',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'normal'
                        }}
                        maxWidth={800}
                        name='text'
                        localeTextID=''
                        text='BUY'
                    />
                </Sprite>
                <Sprite>
                    <Image name='btn' src='popup_button_inactive' />
                    <Text
                        position={[150, 76]}
                        style={{
                            fontFamily: 'Arial',
                            fontSize: 150,
                            fontStyle: 'normal',
                            fill: '#FFFFFF',
                            align: 'center',
                            fontWeight: 'normal'
                        }}
                        maxWidth={800}
                        name='text'
                        localeTextID=''
                        text='BUY'
                    />
                </Sprite>
            </Button>
        </Sprite>
        <Sprite name='buyPopup'>
            <Sprite name='closeButton'>
                <Button hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='cross_bonus'>
                    <Sprite>
                        <Image src='cross_bonus_normal' />
                    </Sprite>
                    <Sprite>
                        <Image src='cross_bonus_focusedl' />
                    </Sprite>
                    <Sprite>
                        <Image src='cross_bonus_pressed' />
                    </Sprite>
                    <Sprite>
                        <Image src='cross_bonus_disabled' />
                    </Sprite>
                </Button>
            </Sprite>
            <Sprite name='rubyBonus'>
                <Image position={[110, -140]} name='ruby' src='ruby_bonus' />
                <Text
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 190,
                        fontStyle: 'normal',
                        fill: '#FF0000',
                        align: 'right',
                        fontWeight: 'normal'
                    }}
                    maxWidth={700}
                    name='rubyValueText'
                    localeTextID=''
                    text='2000'
                />
            </Sprite>
            <Sprite name='bonusCost'>
                <Text
                    position={[0, -10]}
                    anchor={[0.5, 0.5]}
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 190,
                        fontStyle: 'normal',
                        fill: '#FFFF00',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    name='plusText'
                    localeTextID=''
                    text='+'
                />
                <Text
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 190,
                        fontStyle: 'normal',
                        fill: '#FFFF00',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    maxWidth={900}
                    name='realValueText'
                    localeTextID=''
                    text='$99999.99'
                />
            </Sprite>
            <Sprite name='playBonusAt'>
                <Text
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 190,
                        fontStyle: 'normal',
                        fill: '#FFFF00',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    maxWidth={2200}
                    name='playAtText'
                    localeTextID=''
                    text='PLAY BONUS AT'
                />
            </Sprite>
            <Sprite name='bonusBet'>
                <Text
                    position={[-350, 60]}
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 150,
                        fontStyle: 'normal',
                        fill: '#FFFFFF',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    maxWidth={700}
                    name='betText'
                    localeTextID=''
                    text='1$'
                />
                <Text
                    position={[0, 180]}
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 120,
                        fontStyle: 'normal',
                        fill: '#FFFF00',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    name='totalBetText'
                    localeTextID=''
                    text='totalBet'
                />
                <Button hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='bonusBetPlus'>
                    <Sprite>
                        <Image src='arrow_plus_normal' />
                    </Sprite>
                    <Sprite>
                        <Image src='arrow_plus_focused' />
                    </Sprite>
                    <Sprite>
                        <Image src='arrow_plus_pressed' />
                    </Sprite>
                    <Sprite>
                        <Image src='arrow_plus_disabled' />
                    </Sprite>
                </Button>
                <Button hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='bonusBetMinus'>
                    <Sprite>
                        <Image src='arrow_minus_normal' />
                    </Sprite>
                    <Sprite>
                        <Image src='arrow_minus_focused' />
                    </Sprite>
                    <Sprite>
                        <Image src='arrow_minus_pressed' />
                    </Sprite>
                    <Sprite>
                        <Image src='arrow_minus_disabled' />
                    </Sprite>
                </Button>
            </Sprite>
        </Sprite>
        <Sprite name='rubyBalance'>
            <Text
                position={[-48, 43]}
                style={{ fontFamily: 'Arial', fontSize: 50, fontStyle: 'normal', fill: '#FFFFFF', align: 'center', fontWeight: 'normal' }}
                maxWidth={205}
                name='rubyBalanceText'
                localeTextID=''
                text='9999.99'
            />
            <Image position={[-150, 23]} scale={[0.4, 0.4]} src='ruby_bonus' />
        </Sprite>
    </Sprite>
);
